export default __webpack_public_path__ + "static/media/impact-design.7ede86e2.png";